import { render, staticRenderFns } from "./TermsAndConditionsDoc.vue?vue&type=template&id=a1efabde&scoped=true"
import script from "./TermsAndConditionsDoc.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditionsDoc.vue?vue&type=script&lang=ts"
import style0 from "./TermsAndConditionsDoc.vue?vue&type=style&index=0&id=a1efabde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1efabde",
  null
  
)

export default component.exports